import z from 'zod';

export const BarcodeModel = z.object({
    code: z.string(),
    type: z.string().nullish(),
});
export type BarcodeModel = z.infer<typeof BarcodeModel>;
